import { render, staticRenderFns } from "./Discover.vue?vue&type=template&id=c242182e&scoped=true"
import script from "./Discover.vue?vue&type=script&lang=js"
export * from "./Discover.vue?vue&type=script&lang=js"
import style0 from "./Discover.vue?vue&type=style&index=0&id=c242182e&prod&lang=scss"
import style1 from "./Discover.vue?vue&type=style&index=1&id=c242182e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c242182e",
  null
  
)

export default component.exports